export const getRecursiveArray = <T>(arr: T[], path: string) => {
  const placeholderArray: T[] = [];
  arr.forEach((child: T) => {
    // @ts-ignore
    const children = child[path];
    if (children) {
      // @ts-ignore
      placeholderArray.push(...child[path]);
      // @ts-ignore
      getRecursiveArray(child[path], path);
    }
  });
  return placeholderArray;
};
